import "core-js/modules/es.array.includes.js";
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default() {
        return $t("e0bz33", "密码:");
      }
    },
    // 设置密码弹窗需要更明确的新密码提示，默认值保持登录等旧场景不变。
    placeholder: {
      type: String,
      default() {
        return $t("2j9vj05", "请输入密码");
      }
    }
  },
  data() {
    return {
      showtip: false,
      InputTypeMap: {
        true: {
          type: "text",
          icon: "ios-eye-outline"
        },
        false: {
          type: "password",
          icon: "ios-eye-off-outline"
        }
      },
      isShow: false
    };
  },
  methods: {
    changeEye() {
      this.isShow = !this.isShow;
    },
    change($event) {
      this.showtip = true;
      this.$emit("input", $event.target.value);
    },
    validate() {
      this.showtip = true;
      return ["weak", "strong", "medium"].includes(this.strengthLevel);
    },
    resetFields() {
      this.showtip = false;
    }
  },
  computed: {
    inputType() {
      return this.InputTypeMap[this.isShow];
    },
    strengthLevel() {
      const getPasswordStrengthLevel = () => {
        // 提前检查中文和长度
        const chineseRegex = /[\u4e00-\u9fa5]/;
        if (chineseRegex.test(this.value)) return "chinese";
        if (this.value.length === 0) return "none";
        if (this.value.length < 8 || this.value.length > 20) return "unvalid";
        // 检查4种字符类型是否存在
        // eslint-disable-next-line no-useless-escape
        const hasLower = /[a-z]/.test(this.value);
        // eslint-disable-next-line no-useless-escape
        const hasUpper = /[A-Z]/.test(this.value);
        // eslint-disable-next-line no-useless-escape
        const hasDigit = /\d/.test(this.value);
        // eslint-disable-next-line no-useless-escape
        const hasSymbol = /[!@#$%^&*()_+\-=\[\]{}|:"\\.,<>?\/]/.test(this.value);

        // 计算满足的条件数量
        const conditionsMet = [hasLower, hasUpper, hasDigit, hasSymbol].filter(Boolean).length;

        // 根据条件数量判断强度
        if (conditionsMet === 4) return "strong";
        if (conditionsMet >= 2 && conditionsMet <= 3) return "medium"; // 2-3种条件为中等
        if (conditionsMet === 1) return "weak";
        return "unvalid";
      };
      return getPasswordStrengthLevel();
    },
    validTip() {
      let validMap = {
        none: {
          color: "#ed4014",
          text: $t("pcjrt76", "密码不能为空")
        },
        chinese: {
          color: "#ed4014",
          text: $t("q3qhzdd", "密码不符合规则，请重新输入")
        },
        unvalid: {
          color: "#ed4014",
          text: $t("1oupcz8", "密码长度不足8位")
        },
        weak: {
          color: "#FF3456",
          text: $t("72jzl1f", "密码强度(弱)：仅符合最低长度")
        },
        medium: {
          color: "#EC7B2F",
          text: $t("8s1oo1l", "密码强度(中)：尝试添加大小写/数字/符号")
        },
        strong: {
          color: "#13C194",
          text: $t("758f71h", "密码强度(强)：满足所有复杂度要求")
        }
      };
      return validMap[this.strengthLevel];
    },
    errorClass() {
      return this.showtip && !["weak", "medium", "strong"].includes(this.strengthLevel) ? "ivu-form-item-error" : "";
    }
  }
};